import { render } from "./App.vue?vue&type=template&id=43f9f60c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=43f9f60c&lang=css"

import exportComponent from "/codebuild/output/src2517490718/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__